module.exports = __webpack_public_path__ + "img/mx_seguromovil.44ac6611.svg";